import './Icons.scss';
import Card from 'components/chrome/Card';
import React from 'react';
import img_001_payment from 'img/icons/001-payment.svg';
import img_002_internet from 'img/icons/002-internet.svg';
import img_003_smartphone from 'img/icons/003-smartphone.svg';
import img_004_shopping_bag from 'img/icons/004-shopping-bag.svg';
import img_005_computer from 'img/icons/005-computer.svg';
import img_006_streaming from 'img/icons/006-streaming.svg';
import img_007_folder from 'img/icons/007-folder.svg';
import img_008_folder_1 from 'img/icons/008-folder-1.svg';
import img_009_support from 'img/icons/009-support.svg';
import img_010_folder_2 from 'img/icons/010-folder-2.svg';
import img_011_web_payment from 'img/icons/011-web-payment.svg';
import img_012_email from 'img/icons/012-email.svg';
import img_013_computer_1 from 'img/icons/013-computer-1.svg';
import img_014_chat from 'img/icons/014-chat.svg';
import img_015_credit_card from 'img/icons/015-credit-card.svg';
import img_016_online_service from 'img/icons/016-online-service.svg';
import img_017_cloud_storage from 'img/icons/017-cloud-storage.svg';
import img_018_server from 'img/icons/018-server.svg';
import img_019_online_support from 'img/icons/019-online-support.svg';
import img_020_smartphone_1 from 'img/icons/020-smartphone-1.svg';
import img_021_smartphone_2 from 'img/icons/021-smartphone-2.svg';
import img_022_file_sharing from 'img/icons/022-file-sharing.svg';
import img_023_online_shopping from 'img/icons/023-online-shopping.svg';
import img_024_server_1 from 'img/icons/024-server-1.svg';
import img_025_video_call from 'img/icons/025-video-call.svg';
import img_026_file_sharing_1 from 'img/icons/026-file-sharing-1.svg';
import img_027_cloud_storage_1 from 'img/icons/027-cloud-storage-1.svg';
import img_028_computer_2 from 'img/icons/028-computer-2.svg';
import img_029_smartphone_3 from 'img/icons/029-smartphone-3.svg';
import img_030_news from 'img/icons/030-news.svg';
import img_031_file_sharing_2 from 'img/icons/031-file-sharing-2.svg';
import img_032_video_call_1 from 'img/icons/032-video-call-1.svg';
import img_033_connection from 'img/icons/033-connection.svg';
import img_034_email_1 from 'img/icons/034-email-1.svg';
import img_035_computer_3 from 'img/icons/035-computer-3.svg';
import img_036_support_1 from 'img/icons/036-support-1.svg';
import img_037_delivery from 'img/icons/037-delivery.svg';
import img_038_online_tracking from 'img/icons/038-online-tracking.svg';
import img_039_smartwatch from 'img/icons/039-smartwatch.svg';
import img_040_world from 'img/icons/040-world.svg';
import img_041_online_support_1 from 'img/icons/041-online-support-1.svg';
import img_042_cloud_storage_2 from 'img/icons/042-cloud-storage-2.svg';
import img_043_email_2 from 'img/icons/043-email-2.svg';
import img_044_communications from 'img/icons/044-communications.svg';
import img_045_smartphone_4 from 'img/icons/045-smartphone-4.svg';
import img_046_security from 'img/icons/046-security.svg';
import img_047_mobile_shop from 'img/icons/047-mobile-shop.svg';
import img_048_folder_3 from 'img/icons/048-folder-3.svg';
import img_049_sharing from 'img/icons/049-sharing.svg';
import img_050_email_3 from 'img/icons/050-email-3.svg';


const NAMES = [
  'img/icons/001-payment.svg',
  'img/icons/002-internet.svg',
  'img/icons/003-smartphone.svg',
  'img/icons/004-shopping-bag.svg',
  'img/icons/005-computer.svg',
  'img/icons/006-streaming.svg',
  'img/icons/007-folder.svg',
  'img/icons/008-folder-1.svg',
  'img/icons/009-support.svg',
  'img/icons/010-folder-2.svg',
  'img/icons/011-web-payment.svg',
  'img/icons/012-email.svg',
  'img/icons/013-computer-1.svg',
  'img/icons/014-chat.svg',
  'img/icons/015-credit-card.svg',
  'img/icons/016-online-service.svg',
  'img/icons/017-cloud-storage.svg',
  'img/icons/018-server.svg',
  'img/icons/019-online-support.svg',
  'img/icons/020-smartphone-1.svg',
  'img/icons/021-smartphone-2.svg',
  'img/icons/022-file-sharing.svg',
  'img/icons/023-online-shopping.svg',
  'img/icons/024-server-1.svg',
  'img/icons/025-video-call.svg',
  'img/icons/026-file-sharing-1.svg',
  'img/icons/027-cloud-storage-1.svg',
  'img/icons/028-computer-2.svg',
  'img/icons/029-smartphone-3.svg',
  'img/icons/030-news.svg',
  'img/icons/031-file-sharing-2.svg',
  'img/icons/032-video-call-1.svg',
  'img/icons/033-connection.svg',
  'img/icons/034-email-1.svg',
  'img/icons/035-computer-3.svg',
  'img/icons/036-support-1.svg',
  'img/icons/037-delivery.svg',
  'img/icons/038-online-tracking.svg',
  'img/icons/039-smartwatch.svg',
  'img/icons/040-world.svg',
  'img/icons/041-online-support-1.svg',
  'img/icons/042-cloud-storage-2.svg',
  'img/icons/043-email-2.svg',
  'img/icons/044-communications.svg',
  'img/icons/045-smartphone-4.svg',
  'img/icons/046-security.svg',
  'img/icons/047-mobile-shop.svg',
  'img/icons/048-folder-3.svg',
  'img/icons/049-sharing.svg',
  'img/icons/050-email-3.svg',
];

const MAP = {
  'img/icons/001-payment.svg': img_001_payment,
  'img/icons/002-internet.svg': img_002_internet,
  'img/icons/003-smartphone.svg': img_003_smartphone,
  'img/icons/004-shopping-bag.svg': img_004_shopping_bag,
  'img/icons/005-computer.svg': img_005_computer,
  'img/icons/006-streaming.svg': img_006_streaming,
  'img/icons/007-folder.svg': img_007_folder,
  'img/icons/008-folder-1.svg': img_008_folder_1,
  'img/icons/009-support.svg': img_009_support,
  'img/icons/010-folder-2.svg': img_010_folder_2,
  'img/icons/011-web-payment.svg': img_011_web_payment,
  'img/icons/012-email.svg': img_012_email,
  'img/icons/013-computer-1.svg': img_013_computer_1,
  'img/icons/014-chat.svg': img_014_chat,
  'img/icons/015-credit-card.svg': img_015_credit_card,
  'img/icons/016-online-service.svg': img_016_online_service,
  'img/icons/017-cloud-storage.svg': img_017_cloud_storage,
  'img/icons/018-server.svg': img_018_server,
  'img/icons/019-online-support.svg': img_019_online_support,
  'img/icons/020-smartphone-1.svg': img_020_smartphone_1,
  'img/icons/021-smartphone-2.svg': img_021_smartphone_2,
  'img/icons/022-file-sharing.svg': img_022_file_sharing,
  'img/icons/023-online-shopping.svg': img_023_online_shopping,
  'img/icons/024-server-1.svg': img_024_server_1,
  'img/icons/025-video-call.svg': img_025_video_call,
  'img/icons/026-file-sharing-1.svg': img_026_file_sharing_1,
  'img/icons/027-cloud-storage-1.svg': img_027_cloud_storage_1,
  'img/icons/028-computer-2.svg': img_028_computer_2,
  'img/icons/029-smartphone-3.svg': img_029_smartphone_3,
  'img/icons/030-news.svg': img_030_news,
  'img/icons/031-file-sharing-2.svg': img_031_file_sharing_2,
  'img/icons/032-video-call-1.svg': img_032_video_call_1,
  'img/icons/033-connection.svg': img_033_connection,
  'img/icons/034-email-1.svg': img_034_email_1,
  'img/icons/035-computer-3.svg': img_035_computer_3,
  'img/icons/036-support-1.svg': img_036_support_1,
  'img/icons/037-delivery.svg': img_037_delivery,
  'img/icons/038-online-tracking.svg': img_038_online_tracking,
  'img/icons/039-smartwatch.svg': img_039_smartwatch,
  'img/icons/040-world.svg': img_040_world,
  'img/icons/041-online-support-1.svg': img_041_online_support_1,
  'img/icons/042-cloud-storage-2.svg': img_042_cloud_storage_2,
  'img/icons/043-email-2.svg': img_043_email_2,
  'img/icons/044-communications.svg': img_044_communications,
  'img/icons/045-smartphone-4.svg': img_045_smartphone_4,
  'img/icons/046-security.svg': img_046_security,
  'img/icons/047-mobile-shop.svg': img_047_mobile_shop,
  'img/icons/048-folder-3.svg': img_048_folder_3,
  'img/icons/049-sharing.svg': img_049_sharing,
  'img/icons/050-email-3.svg': img_050_email_3,
};

class Icons extends React.Component {
  renderIcon(name) {
    return (
      <div className='container p-col-2' key={name}>
        <Card
            img={MAP[name]}
            text={name}
            />
      </div>
    );
  }

  render() {
    return (
      <div className='section'>
        <div className='p-grid'>
          {NAMES.map(this.renderIcon)}
        </div>
      </div>
    );
  }
}


export default Icons;
